import { render, staticRenderFns } from "./NovaFaltaJustificadaPage.vue?vue&type=template&id=0fd5b0b0"
import script from "./NovaFaltaJustificadaPage.vue?vue&type=script&lang=js"
export * from "./NovaFaltaJustificadaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports